export const MILESTONE_FIELDS = `
  id
  alias
  title
  type
  status
  description
  rejectionReason
  businessOutcomes
  initialPlannedDate
  currentPlannedDate
  completionDate
  rejectionDate
  comment
`;
